<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar" /> 生产管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form ref="searchform" :model="searchform" label-width="110px" @keyup.enter.native="search()">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="调拨单号" prop="transferOrderNo">
                                <el-input v-model="searchform.transferOrderNo" type="text" placeholder="请输入调拨单号" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="码" prop="qrCode">
                                <el-input v-model="searchform.qrCode" type="text" placeholder="请输入码" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="状态" prop="status">
                                <el-select style="width: 100%;" v-model="searchform.status" placeholder="请选择状态">
                                    <el-option label="待出库" :value="0"></el-option>
                                    <el-option label="出库中" :value="1"></el-option>
                                    <el-option label="部分出库" :value="2"></el-option>
                                    <el-option label="已完成" :value="3"></el-option>
                                    <el-option label="已取消" :value="4"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="时间" prop="datelist">
                                <el-date-picker v-model="searchform.datelist" style="width: 100%" type="daterange"
                                    value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期"
                                    end-placeholder="结束日期" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" :offset="1">
                            <el-button type="primary" icon="el-icon-search" @click="search()">搜索
                            </el-button>
                            <el-button @click="resetForm('searchform')">重置</el-button>

                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <br />
            <br />
            <el-row type="flex" class="row-bg">
                <el-col :span="24" class="border">
                    <h4>{{ $route.meta.title }}</h4>
                    <el-divider></el-divider>
                    <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData"
                        style="width: 100%" id="parent">
                        <el-table-column prop="transferOrderNo" label="调拨单号" min-width="150" show-overflow-tooltip />
                        <el-table-column prop="productCode" label="产品编码" min-width="110" show-overflow-tooltip />
                        <el-table-column prop="productName" label="产品名称" min-width="200" show-overflow-tooltip />
                        <el-table-column prop="packageLevel" label="包装级别" min-width="70" show-overflow-tooltip />
                        <el-table-column prop="produceBatchNo" label="生产批次" min-width="130" show-overflow-tooltip />
                        <el-table-column prop="batchNo" label="调拨批次" min-width="140" show-overflow-tooltip />
                        <el-table-column prop="numRelation" label="数量" min-width="50" show-overflow-tooltip />
                        <el-table-column prop="qrCodeParent" label="父级码" min-width="170" show-overflow-tooltip />
                        <el-table-column prop="qrCode" label="子级码" min-width="170" show-overflow-tooltip />
                        <el-table-column prop="pdaIdent" label="PDA唯一码" min-width="140" show-overflow-tooltip />
                        <el-table-column prop="scanUnitCode" label="单位编码" min-width="80" show-overflow-tooltip />
                        <el-table-column prop="scanUnitName" label="单位名称" min-width="80" show-overflow-tooltip />
                        <el-table-column prop="scanTime" label="扫码时间" min-width="140" show-overflow-tooltip>
                            <template slot-scope="scope">{{ $parseTime(scope.row.scanTime) }} </template>
                        </el-table-column>
                        <el-table-column prop="status" label="状态" min-width="80" show-overflow-tooltip>
                            <template slot-scope="scope">{{ statusList[scope.row.status] }}</template>
                        </el-table-column>
                        <el-table-column prop="traceDownloadStatusDesc" label="下载状态" min-width="80"
                            show-overflow-tooltip />
                        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />
                    </el-table>
                    <br />
                    <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 40, 100]"
                        layout="total,prev, pager, next,jumper,sizes" :total="total_count"
                        @current-change="currentchange" @size-change="pagesize" />
                </el-col>
            </el-row>

        </div>
    </div>
</template>
<script>
import {
    transferScanList
} from "@/api/production";
export default {
    name: "transferOutOrderScan",
    data() {
        return {
            show: false,
            // 基础数据
            add: {
                addshow: false,
            },
            listLoading: false,
            tableData: [],
            // 分页数据
            pagesizes: "",
            total_count: 1,
            currentPage: 1,
            searchform: {
                transferOrderNo: null,
                qrCode: null,
                datelist: [],
                status: null,
                pageIndex: 1,
                pageSize: 10,
            },
            statusList: ['待出库', '出库中', '部分出库', '已完成', '已取消']
        };
    },
    mounted() {
        // 请求部门列表数据并且便利到表格
        this.search();

    },
    methods: {
        Tabledata(obj) {
            // 列表获取
            this.listLoading = true;
            transferScanList(obj).then((response) => {
                this.tableData = response.data.items
                this.currentPage = response.data.page_index;
                this.total_count = response.data.total;
                this.listLoading = false;
            });
        },
        // 搜索事件
        search() {
            const params = this.searchform
            params.plan_date = this.searchform.plan_date ? null : this.searchform.plan_date
            params.startDateStr =
                this.searchform.datelist == null ? null : this.searchform.datelist[0]
            params.endDateStr =
                this.searchform.datelist == null ? null : this.searchform.datelist[1]
            this.Tabledata(params);
        },
        // 重置按钮
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.search()
        },
        // 分页跳转事件
        currentchange(page_index) {
            this.searchform.pageIndex = page_index;
            const params = this.searchform
            params.plan_date = this.searchform.plan_date ? null : this.searchform.plan_date
            this.Tabledata(params);
        },
        // 分页每页显示条数事件
        pagesize(page_size) {
            this.searchform.pageSize = page_size;
            this.search();
        },
    },
};
</script>
<style scoped>
.rightclass {
    z-index: 9999;
}

.bottstycz {
    display: block !important;
    width: 150px;
    margin: 5px;
}
</style>